export default __webpack_public_path__ + "static/media/Version (1) - Hobbit_05.0819effa.jpg";